import { BLEND_MODES } from 'pixi.js';

import { BlendMode } from 'js/types';

interface BlendModeOption {
  key: BlendMode;
  label: string;
}

export const BLEND_MODE_OPTIONS: BlendModeOption[] = [
  {
    key: BlendMode.Normal,
    label: 'Normal'
  },
  {
    key: BlendMode.Multiply,
    label: 'Multiply'
  },
  {
    key: BlendMode.Add,
    label: 'Add'
  },
  {
    key: BlendMode.Difference,
    label: 'Difference'
  },
  {
    key: BlendMode.Screen,
    label: 'Screen'
  },
  {
    key: BlendMode.Subtract,
    label: 'Subtract'
  },
  {
    key: BlendMode.Darken,
    label: 'Darken'
  },
  {
    key: BlendMode.Lighten,
    label: 'Lighten'
  },
  {
    key: BlendMode.Overlay,
    label: 'Overlay'
  },
  {
    key: BlendMode.Exclusion,
    label: 'Exclusion'
  },
  {
    key: BlendMode.Tint,
    label: 'Tint'
  }
];

export const blendModeToFabricKey = (blendMode: BlendMode): string => {
  if (blendMode === BlendMode.Difference) return 'diff';
  return blendMode.toString();
};

export const blendModeToPixiKey = (blendMode: BlendMode): BLEND_MODES | undefined => {
  if (!blendMode) return;
  if (blendMode === BlendMode.Tint) return 'color';
  return blendMode.toString() as BLEND_MODES;
};

// Mapping table for standard vs. custom compositing behavior
export const FABRIC_BLEND_MODE_MAP = {
  [BlendMode.Normal]: 'source-over',
  [BlendMode.Multiply]: 'multiply',
  [BlendMode.Screen]: 'screen',
  [BlendMode.Overlay]: 'overlay',
  [BlendMode.Darken]: 'darken',
  [BlendMode.Lighten]: 'lighten',
  [BlendMode.Difference]: 'difference',
  [BlendMode.Exclusion]: 'exclusion',
  // Tint is the UI/persisted name for standard Color blending in both renderers.
  [BlendMode.Tint]: 'color',
  // Non-standard compositing requires a custom fallback hook
  [BlendMode.Add]: 'custom-add',
  [BlendMode.Subtract]: 'custom-subtract'
};
